import { useState, useEffect } from 'react';
import { getJobs, createJob, updateJob, deleteJob } from '../firebase/db';
import { useAuth } from '../contexts/AuthContext';
import { useDemo } from '../contexts/DemoContext';
import { generateDemoJobs } from '../demo/demoData';

export const useJobs = () => {
  const { user, profile, isAdmin, isManager } = useAuth();
  const { demoMode } = useDemo();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchJobs = async () => {
    setLoading(true);
    if (demoMode) {
      setJobs(generateDemoJobs());
      setLoading(false);
      return;
    }
    const data = (isAdmin || isManager) ? await getJobs() : await getJobs(user?.uid);
    setJobs(data);
    setLoading(false);
  };

  const addJob = async (jobData) => {
    if (demoMode) {
      const newJob = { id: 'demo_' + Date.now(), ...jobData, createdAt: new Date().toISOString() };
      setJobs((prev) => [...prev, newJob]);
      return { id: newJob.id, error: null };
    }
    return await createJob(jobData);
  };

  const editJob = async (id, jobData) => {
    if (demoMode) {
      setJobs((prev) => prev.map((j) => (j.id === id ? { ...j, ...jobData } : j)));
      return { error: null };
    }
    return await updateJob(id, jobData);
  };

  const removeJob = async (id) => {
    if (demoMode) {
      setJobs((prev) => prev.filter((j) => j.id !== id));
      return { error: null };
    }
    const result = await deleteJob(id);
    // Refresh local state so the list updates immediately
    if (!result.error) {
      setJobs((prev) => prev.filter((j) => j.id !== id));
    }
    return result;
  };

  useEffect(() => {
    if (user || demoMode) fetchJobs();
  }, [user, demoMode, isAdmin, isManager]);

  return { jobs, loading, fetchJobs, addJob, editJob, removeJob };
};
